import { httpRequest } from "@services/http"

export type CampaignTableMetrics = {
  spend_total: number
  impression_count: number
  clicks_total: number
  total_conversions: number
}

/** Where a campaign is in its life (MPN-1578). Derived server-side from the go-live
    stamp, the schedule and the network links -- never stored, so it cannot go stale. */
export type CampaignStatus = "ONBOARDING" | "LIVE" | "ENDED"

export type CampaignTableRow = CampaignTableMetrics & {
  id: number
  name: string
  has_population_segment: boolean
  /** "Campaign Start Date" in the UI: when it actually first published, null until then. */
  go_live_date: string | null
  status: CampaignStatus | null
}

export type CampaignTableGroup = {
  id: number | null // null is the group of campaigns with no objective
  name: string | null
  campaigns: CampaignTableRow[]
  totals: CampaignTableMetrics
}

export type CampaignTable = {
  objectives: CampaignTableGroup[]
  totals: CampaignTableMetrics
}

/*
    The Monitor overview table. Its own request rather than a chart in the big
    analytics payload: the overview needs none of the nineteen chart datasets,
    and ChartSerializer indexes those keys unguarded, so it cannot deserialize a
    partial charts response.
*/
export class CommandGetCampaignTable {
  async run(engagementId: number): Promise<CampaignTable> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/analytics/?charts=campaign-table`
    const response = await httpRequest<any>(url, { method: "GET" })
    return (
      response?.charts?.["campaign-table"] ?? { objectives: [], totals: EMPTY_METRICS }
    )
  }
}

const EMPTY_METRICS: CampaignTableMetrics = {
  spend_total: 0,
  impression_count: 0,
  clicks_total: 0,
  total_conversions: 0,
}
